import { navigate } from 'gatsby'
import { motion } from 'framer-motion'
import loadable from '@loadable/component'

import classNames from 'classnames'
import Navbar from './Navbar'
import { PAGES_SLUG } from '@/constants/pages'

const Arrow = loadable(() => import('@vhl/icons'), {
  resolveComponent: component => component.Arrow,
})
const ArrowUpRight = loadable(() => import('@vhl/icons'), {
  resolveComponent: component => component.ArrowUpRight,
})

interface SideBoxProps {
  title: string
  onClick?: React.MouseEventHandler
  type?: 'toggle' | 'link'
}

function SideBox({ title, onClick, type = 'toggle' }: SideBoxProps) {
  const isToggleType = type === 'toggle'
  const sideBoxClass = classNames(
    'py-4 px-2 lg:p-6 cursor-pointer flex flex-row group',
    { 'justify-between items-center': isToggleType },
    { 'space-x-4 items-start': !isToggleType }
  )
  const arrowClass = classNames(
    'w-9 h-9 stroke-black group-hover:stroke-blue-500 transition transform duration-300',
    {
      'opacity-0 group-hover:opacity-100 group-hover:-translate-x-1': isToggleType,
    },
    { 'translate-y-1 group-hover:-translate-y-1': !isToggleType }
  )

  return (
    <motion.div className={sideBoxClass} onClick={onClick}>
      <h1 className="transition duration-300 transform group-hover:text-blue-500 heading-5 md:heading-4 lg:heading-3">
        {title}
      </h1>
      {isToggleType ? (
        <Arrow className={arrowClass} />
      ) : (
        <ArrowUpRight className={arrowClass} />
      )}
    </motion.div>
  )
}

const VerticalSidebar = ({ setSidebarType }: { setSidebarType: any }) => {
  return (
    <>
      <Navbar />
      <div className="px-5">
        <hr />
        <SideBox
          title="Tình trạng sức khỏe"
          onClick={() => setSidebarType('healthstatus')}
        />
        <hr />
        <SideBox title="Chuyên mục" onClick={() => setSidebarType('topic')} />
        <hr />
        <SideBox
          title="Về chúng tôi"
          type="link"
          onClick={() => navigate(PAGES_SLUG.about)}
        />
        <hr />
      </div>
    </>
  )
}

export default VerticalSidebar
